import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import TextField from '../GeneralTextField';

import styles from './styles';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  onAddress: PropTypes.func,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  errMsg: PropTypes.string,
  touched: PropTypes.bool,
  invalid: PropTypes.bool,
  classes: PropTypes.shape({
    suggestionItem: PropTypes.string,
    suggestionItemActive: PropTypes.string,
    suggestionsContainer: PropTypes.string,
    root: PropTypes.string,
  }).isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onGettingCoord: PropTypes.func,
  onClearCoord: PropTypes.func,
  disabled: PropTypes.bool,
  additionalRestrictions: PropTypes.shape(),
  filterType: PropTypes.string,
};

const defaultProps = {
  value: '',
  onGettingCoord: () => {},
  onClearCoord: () => {},
};

export const PlaceSearchFormField = props => {
  const {
    label,
    value,
    id,
    onChange,
    onGettingCoord,
    onClearCoord,
    onBlur,
    onFocus,
    errMsg,
    touched,
    invalid,
    classes,
    disabled,
    additionalRestrictions,
    filterType,
    onAddress,
  } = props;

  const handleChange = newValue => {
    onClearCoord();
    onChange(newValue);
  };

  const handleSelect = async address => {
    const results = await geocodeByAddress(address);
    if (onAddress) onAddress(results[0]);
    const latLong = await getLatLng(results[0]);
    if (onGettingCoord) onGettingCoord(latLong);
    onChange(address);
  };

  const handleBlur = () => {
    if (onBlur) onBlur(value);
  };

  const restrictions = additionalRestrictions || {};

  return (
    <PlacesAutocomplete
      value={value}
      onChange={handleChange}
      onSelect={handleSelect}
      searchOptions={{
        componentRestrictions: { country: 'au' },
        additionalRestrictions: { types: ['establishment'] },
        ...restrictions,
      }}
      highlightFirstSuggestion
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div className={classes.root}>
          <TextField
            {...getInputProps({})}
            id={id}
            label={label}
            fullWidth
            onBlur={handleBlur}
            onFocus={onFocus}
            touched={touched}
            invalid={invalid}
            errMsg={errMsg}
            disabled={disabled}
          />
          <div className={classes.suggestionsContainer}>
            {loading && <div>Loading...</div>}
            {suggestions
              .filter(item => {
                if (filterType) {
                  return item.types.includes(filterType);
                }
                return true;
              })
              .map(suggestion => {
                const className = suggestion.active
                  ? classNames(
                      classes.suggestionItem,
                      classes.suggestionItemActive,
                    )
                  : classes.suggestionItem;

                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};

PlaceSearchFormField.propTypes = propTypes;
PlaceSearchFormField.defaultProps = defaultProps;

export default withStyles(styles)(PlaceSearchFormField);
